export default __webpack_public_path__ + "assets/images/v-icon1-557a632f.svg";